import React from "react";
import styles from "../../../styles/index";
import { IFeedDetailView } from "../../../service/Index";
import { SystemFun } from "codoon-fun";
import TopicFeed from "./TopicFeed";
import "./index.less";

const PREFIX = "TopicModule";

interface IProps {
  label_info: {
    label_content: string;
    normal_feed_list: IFeedDetailView[];
  };
  detail: {
    title?: string;
    topic_id?: number;
  };
}
interface IState {
  assemble_feed_list: Array<IFeedDetailView[]>;
}

class ClubActivityTopic extends React.Component<IProps, {}> {
  public state: IState = {
    assemble_feed_list: [],
  };

  constructor(props: IProps) {
    super(props);
    this.state = {
      assemble_feed_list: this._assembleFeedList(
        props.label_info.normal_feed_list
      ),
    };
  }

  componentWillReceiveProps(nextProps: IProps) {
    if (
      nextProps.label_info.normal_feed_list !=
      this.props.label_info.normal_feed_list
    ) {
      this.setState({
        assemble_feed_list: this._assembleFeedList(
          nextProps.label_info.normal_feed_list
        ),
      });
    }
  }

  /**
   * 组装feed数据,从一维数组变成二维数组
   */
  _assembleFeedList = (normal_feed_list: IFeedDetailView[]): any => {
    return normal_feed_list.reduce(
      (accumulator: Array<IFeedDetailView[]>, currentValue) => {
        let curAccumulator: IFeedDetailView[] =
          accumulator[accumulator.length - 1];
        if (curAccumulator && curAccumulator.length < 2) {
          curAccumulator.push(currentValue);
          return accumulator;
        } else {
          curAccumulator = [];
          curAccumulator.push(currentValue);
          accumulator.push(curAccumulator);
          return accumulator;
        }
      },
      []
    );
  };

  render() {
    const { detail, label_info } = this.props;
    const { assemble_feed_list } = this.state;
    const system = SystemFun.checkSystemByUserAgent();
    let url;
    if (system.isCodoon) {
      url = `https://rn.codoon.com/app/rnapp/feed_detail?label_id=${detail.topic_id}`;
    } else {
      url = `https://www.codoon.com/h5/feed-card/index.html#/home/${detail.topic_id}`;
    }

    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}-title`}>·{detail.title || "参与话题"}·</div>
        <a className={`${PREFIX}-topicName`} href={url} target="_blank">
          #{label_info.label_content}
        </a>
        {assemble_feed_list.map((feeds: IFeedDetailView[], index) => {
          return (
            <div style={styles.feedContainer} key={index} className="clearfix">
              {feeds.map((item: IFeedDetailView) => {
                return <TopicFeed detail={item} key={item.feed_id} />;
              })}
            </div>
          );
        })}
        <a className={`${PREFIX}-moreBtn`} href={url} target="_blank">
          查看更多
        </a>
      </div>
    );
  }
}

export default ClubActivityTopic;
